import { statusOptions } from './constants/statusOptions'
import { SearchQuery } from './filter/SearchQuery'
import { SelectFilter } from './filter/SelectFilter'
import { DateFilter } from '@/containers/billing/register/billingFilters/filter/DateFilter'
import { useShipmentNotificationFilters } from './hooks/useShipmentNotificationFilters'
import { SelectionSummary } from './SelectionSummary'
import { RectangleGroupIcon } from '@heroicons/react/24/outline'
import { useState } from 'react'
import { AdvancedFilters } from './AdvancedFilters'

export const FiltersRow = () => {
  const [selectedDateType, setSelectedDateType] = useState('emision');

  // Use the nuqs-based filter hook
  const {
    filters,
    updateSearch,
    updateShouldArrivedAtFrom,
    updateShouldArrivedAtTo,
    updateStatus,
    clearAllFilters,
    hasActiveFilters,
  } = useShipmentNotificationFilters()

  const handleClearFilters = () => {
    // Clear nuqs filters
    clearAllFilters()
  }

  // Check if any filters are active - now only using nuqs filters
  const hasAnyActiveFilters = hasActiveFilters

  return (
    <div className="mb-2 w-full">
      <div className="flex flex-col gap-4 w-full">
        <div className="flex w-full min-w-0 items-center gap-2">
          <div className="flex-1">
            <SearchQuery
              searchQuery={filters.search}
              onSearchChange={updateSearch}
              placeholder="Buscar notificación..."
            />
          </div>
          <div className="flex flex-wrap items-center gap-2 justify-end">
            <SelectFilter
              title="Estado"
              placeholder="Buscar estado..."
              activeSelections={filters.status}
              onSelectionsChange={updateStatus}
              selectionOptions={statusOptions}
              searchActive={false}
              icon={<RectangleGroupIcon className="h-4 w-4" />}
            />
            <DateFilter
              dateFrom={filters.shouldArrivedAtFrom}
              dateTo={filters.shouldArrivedAtTo}
              selectedDateType={selectedDateType}
              onDateRangeChange={(from, to) => {
                updateShouldArrivedAtFrom(from || '')
                updateShouldArrivedAtTo(to || '')
              }}
              onDateTypeChange={setSelectedDateType}
              hideDateTypeSelect
            />
            <AdvancedFilters />
          </div>
        </div>

        {hasAnyActiveFilters && (
          <SelectionSummary
            status={filters.status}
            setStatus={updateStatus}
            statusOptions={statusOptions}
            shouldArriveAtFrom={filters.shouldArrivedAtFrom}
            setShouldArriveAtFrom={updateShouldArrivedAtFrom}
            shouldArriveAtTo={filters.shouldArrivedAtTo}
            setShouldArriveAtTo={updateShouldArrivedAtTo}
            searchQuery={filters.search}
            setSearchQuery={updateSearch}
            handleClearFilters={handleClearFilters}
          />
        )}
      </div>
    </div>
  )
}
